import { Button } from 'antd';
import { useCurrentUser } from 'client/components/auth/AuthModule';
import { LogoutButton } from 'client/components/auth/logout/LogoutButton';
import { MessageBanner } from 'client/ui/message-banner/MessageBanner';
import { CitizenNationality } from 'common/schema/Citizen';
import { UserSource } from 'common/schema/User';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

/**
 * Banner che avverte l'utente europeo che non è possibile inviare nuove istanze senza
 * un account TrustedSSO
 *
 * (Inserito per l'obbligo per gli utenti EU di passare ad un utente loggato con trustedSSO)
 */
export function EuNotTrustedUserAlertBanner() {
  const user = useCurrentUser();
  const { t } = useTranslation();

  // Il banner è rivolto unicamente agli utenti europei (ita/eu) registrati via mail
  if (
    !user ||
    user.source !== UserSource.EmailRegistration ||
    (user.source === UserSource.EmailRegistration &&
      user.citizen?.nationality === CitizenNationality.ExtraEU) ||
    user.citizen?.nationality == null
  ) {
    return null;
  }

  return (
    <MessageBanner>
      <div style={{ textAlign: 'center' }}>
        {t(
          'user.nationality.alert.banner-text',
          "In seguito alle nuove normative, ai Cittadini Europei non è più permesso inviare istanze senza autenticazione d'identità digitale. Per inviare una nuova istanza sarà effettuare il logout e accedere attraverso il sistema SPID / CIE / eIDAS."
        )}{' '}
        <Button
          size="small"
          children={<LogoutButton hideIcon text="Logout" />}
        />
      </div>
    </MessageBanner>
  );
}
